import * as React from "react";
import classnames from "classnames";
import { useIntl } from "@grandvisionhq/state";
/* empty css                      */
const EyeSideIndicator = ({ className, side }) => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("div", { className: classnames(`eyeside-indicator`, `eyeside-indicator--${side}`, className) }, getLabel(`common.${side}.abbr`));
};
export {
  EyeSideIndicator as default
};
//# sourceMappingURL=EyeSideIndicator.js.map
